module.exports = __webpack_public_path__ + "img/05010008.59975250.jpg";